import React from 'react';

import type {GlossaryItem} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {glossaryDescription, glossaryTypeText} from './glossary-seo-text';

export const GlossarySeo: React.FC<{item: GlossaryItem}> = ({item}) => (
	<EntitySeo
		entity={item}
		section="glossary"
		kind={glossaryTypeText(item).toLowerCase()}
		description={glossaryDescription(item)}
		path={buildUrl('glossaryItem', {id: item.id})}
		og={{kind: 'glossary'}}
	/>
);
